import type { DetailListProps } from '@presentation/components';
import type { ReactNode } from 'react';

export interface DetailListContactData {
  website?: {
    label?: string;
    url?: string | null;
  };
  email?: string;
  phoneNumber?: string;
  mobilePhoneNumber?: string;
  address?: {
    label?: string;
    url?: string;
  };
  blurred?: boolean;
  blurredChildren?: ReactNode;
  labelMaxWidth?: string;
  onWhatsappClick?: () => void;
  enableWhatsAppContact?: boolean;
}

export interface DetailListContactProps
  extends Omit<DetailListProps, 'items'>,
    DetailListContactData {}
